import _ from "lodash";
import { findIndex } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import { ERRORS, EXCEPTIONS, SPREAD } from "../../constants";
import { State } from "../../state";
import { AccountPresenter } from "../model/presenter/types";
import {
  getLanguage,
  getSpreadIncomeStatementsPeriods
} from "../model/spread/selector";
import { Spread } from "../model/spread/types";
import PAFColumn from "./PAFColumn";
import "./PersistentAccountingFormula.scss";

interface NetProfitFooterProps {
  periods: string[];
  netProfitAccount?: AccountPresenter;
  spread?: Spread;
  language?: string | null;
}

interface NetProfitFooterState {
  activePeriodIndex: number;
}

export class NetProfitFooter extends React.Component<
  NetProfitFooterProps,
  NetProfitFooterState
> {
  constructor(props: NetProfitFooterProps) {
    super(props);
    this.state = {
      activePeriodIndex: 0
    };
  }

  public choosePeriod = (event: React.MouseEvent<HTMLButtonElement>) => {
    const activePeriodIndex = findIndex(
      period => period === event.currentTarget.value,
      this.props.periods
    );
    this.setState({ activePeriodIndex });
  };

  public render() {
    const { periods, spread } = this.props;

    const calculatedNetProfit =
      (spread &&
        spread.financialTemplate.totalNetProfitValues[
          this.state.activePeriodIndex
        ]) ||
      0;

    const { readExceptions, reportedValues } = this.generateReportedValues();

    const reportedValue = this.periodValue(reportedValues);

    let totalLabel = SPREAD.FINANCIAL_TEMPLATE.NET_PROFIT_DEFAULT_LABEL;
    let reportedLabel = SPREAD.FINANCIAL_TEMPLATE.NET_PROFIT_DEFAULT_LABEL;

    if (spread && spread.financialTemplate.totalNetProfitLabel) {
      totalLabel = spread.financialTemplate.totalNetProfitLabel;
    }

    if (
      this.props.language &&
      spread &&
      spread.financialTemplate.totalNetProfitTranslatedLabels &&
      spread.financialTemplate.totalNetProfitTranslatedLabels[
        this.props.language
      ]
    ) {
      totalLabel =
        spread.financialTemplate.totalNetProfitTranslatedLabels[
          this.props.language
        ];
    }

    if (spread && spread.financialTemplate.reportedNetProfitLabel) {
      reportedLabel = spread.financialTemplate.reportedNetProfitLabel;
    }

    if (
      this.props.language &&
      spread &&
      spread.financialTemplate.reportedNetProfitTranslatedLabels &&
      spread.financialTemplate.reportedNetProfitTranslatedLabels[
        this.props.language
      ]
    ) {
      reportedLabel =
        spread.financialTemplate.reportedNetProfitTranslatedLabels[
          this.props.language
        ];
    }

    return (
      <div className="PersistentAccountingFormula__container">
        <div className={"PersistentAccountingFormula__periods"}>
          {periods.map((period, index) => {
            const year = period.split("/")[2];
            return (
              <button
                className={this.displayAsActive(index)}
                key={period}
                onClick={this.choosePeriod}
                value={period}
              >
                {year}
              </button>
            );
          })}
        </div>
        <PAFColumn
          header={`CALCULATED ${totalLabel}`.toUpperCase()}
          value={calculatedNetProfit}
        />
        <PAFColumn
          header={`REPORTED ${reportedLabel}`.toUpperCase()}
          value={reportedValue}
          exceptionString={
            readExceptions[this.state.activePeriodIndex] ? "unread" : undefined
          }
        />
        <PAFColumn
          header="DIFFERENCE"
          value={calculatedNetProfit - reportedValue}
          isDifference={true}
          exceptionString={
            readExceptions[this.state.activePeriodIndex] ? "-" : undefined
          }
        />
      </div>
    );
  }

  private generateReportedValues = () => {
    const readExceptions = {};
    const { periods, spread } = this.props;
    const documenteExceptions = (spread && spread.documentExceptions) || [];
    const reportedValues: any[] = [];

    const exceptionOverride = {};

    const netProfitId: any =
      (this.props.spread &&
        this.props.spread.financialTemplate.reportedNetProfitTranslatedLabels &&
        this.props.spread.financialTemplate.reportedNetProfitTranslatedLabels
          .fieldId) ||
      EXCEPTIONS.NET_PROFIT_ID;

    periods.map((period, idx) => {
      const exception = _.find(
        documenteExceptions,
        e =>
          e.period === period &&
          e.sheetName === EXCEPTIONS.SHEET_NAME &&
          e.type === ERRORS.PDF_READ_ERROR &&
          e.firstRow.exceptionValueModels[0].financialValueId.includes(
            netProfitId
          )
      );

      if (!readExceptions[idx] && exception) {
        readExceptions[idx] = exception;
      }

      if (!exceptionOverride[idx]) {
        exceptionOverride[idx] = _.find(
          documenteExceptions,
          e =>
            e.period === period &&
            e.firstRow.exceptionValueModels[0] &&
            e.firstRow.exceptionValueModels[0].financialValueId.includes(
              netProfitId
            )
        );
      }

      let value;

      value =
        exceptionOverride[idx] &&
        exceptionOverride[idx].firstRow.exceptionValueModels[0] &&
        exceptionOverride[idx].firstRow.exceptionValueModels[0].value;

      let v = spread && spread.financialTemplate.totalNetProfitValues[idx];

      if (exceptionOverride[idx] && value) {
        v = value;
      }

      reportedValues.push(v);
    });

    return { readExceptions, reportedValues };
  };

  private periodValue = (valuesForPeriods: Array<number | undefined>) => {
    return valuesForPeriods[this.state.activePeriodIndex] || 0;
  };

  private displayAsActive = (periodIndex: number) => {
    return periodIndex === this.state.activePeriodIndex ? "active" : "inactive";
  };
}

const mapStateToProps = (state: State) => ({
  periods: getSpreadIncomeStatementsPeriods(state),
  language: getLanguage(state)
});

export default connect(mapStateToProps)(NetProfitFooter);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/NetProfitFooter.tsx